<template>
  <div>
    <div class="loading" v-if="store.isAuthenticated && isLoading">
      <LoadingCircle />
      <div class="text">{{ t('____x.loading') }}</div>
    </div>
    <div class="loading" v-if="store.isAuthenticated && isPendingUpdateSubscription">
      <LoadingCircle />
      <div class="text">{{ t('Please wait') }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useStore } from '@/store';
import { useI18n } from '@/composables';
import LoadingCircle from '@/components/global-loaders/circle.vue';

const { t } = useI18n();
const store = useStore();
const { isLoading } = storeToRefs(store);

const isPendingUpdateSubscription = computed(() => {
  const addons = Object.values(store.billingAddons || {}) as PlanAddon[];
  return addons.find(item => item.pending) || !!store.billing.pending;
});
</script>

<style lang="scss" scoped>
.loading {
  position: fixed;
  top: 0;
  left: calc(50% - 53px);
  background-color: #18a689;
  border-radius: 0 0 5px 5px;
  padding: 8px 16px;
  text-align: center;
  align-items: center;
  color: #fff;
  z-index: 10100;
  font-size: 13px;
  display: flex;
}

.text {
  line-height: 1;
}

.loading .circle-wrp {
  margin: 0 7px 0 0;
  float: left;
  width: 15px;
  height: 15px;
  position: relative;
}

.circle-wrp .sk-circle {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.circle-wrp .sk-circle:before {
  content: '';
  display: block;
  margin: 0 auto;
  width: 2px;
  height: 2px;
  background-color: #fff;
  border-radius: 100%;
  animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;
}

.circle-wrp .sk-circle2 {
  transform: rotate(30deg);
}

.circle-wrp .sk-circle3 {
  transform: rotate(60deg);
}

.circle-wrp .sk-circle4 {
  transform: rotate(90deg);
}

.circle-wrp .sk-circle5 {
  transform: rotate(120deg);
}

.circle-wrp .sk-circle6 {
  transform: rotate(150deg);
}

.circle-wrp .sk-circle7 {
  transform: rotate(180deg);
}

.circle-wrp .sk-circle8 {
  transform: rotate(210deg);
}

.circle-wrp .sk-circle9 {
  transform: rotate(240deg);
}

.circle-wrp .sk-circle10 {
  transform: rotate(270deg);
}

.circle-wrp .sk-circle11 {
  transform: rotate(300deg);
}

.circle-wrp .sk-circle12 {
  transform: rotate(330deg);
}

.circle-wrp .sk-circle2:before {
  animation-delay: -1.1s;
}

.circle-wrp .sk-circle3:before {
  animation-delay: -1s;
}

.circle-wrp .sk-circle4:before {
  animation-delay: -0.9s;
}

.circle-wrp .sk-circle5:before {
  animation-delay: -0.8s;
}

.circle-wrp .sk-circle6:before {
  animation-delay: -0.7s;
}

.circle-wrp .sk-circle7:before {
  animation-delay: -0.6s;
}

.circle-wrp .sk-circle8:before {
  animation-delay: -0.5s;
}

.circle-wrp .sk-circle9:before {
  animation-delay: -0.4s;
}

.circle-wrp .sk-circle10:before {
  animation-delay: -0.3s;
}

.circle-wrp .sk-circle11:before {
  animation-delay: -0.2s;
}

.circle-wrp .sk-circle12:before {
  animation-delay: -0.1s;
}

@-webkit-keyframes sk-circleFadeDelay {
  0%,
  39%,
  100% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
}

@keyframes sk-circleFadeDelay {
  0%,
  39%,
  100% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
}
</style>
